//Tabla de proyectos
import React, { useState, useEffect } from 'react';
import { PROYECTOS_COLLECTION, StatusBadge} from '../../utils/constants'
import { formatDate } from '../../utils/helpers';
import { db } from '../../firebase/config'
import { 
    collection, query, where, getDocs, doc, updateDoc, onSnapshot, 
    deleteDoc
} from 'firebase/firestore';

import 'react-toastify/dist/ReactToastify.css';
import { ConfirmationModal } from '../UI/ConfirmationModal'

export const ProjectsTable = ({projects, userRole, supervisorView, onManageClick, onAssignClick}) => {
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [invoicesMap, setInvoicesMap] = useState({});
    const [confirmingAction, setConfirmingAction] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchExtraData = () => {
            const qTechsOld = query(collection(db, "usuarios"), where("rol", "==", "tecnico"));
            const qTechsNew = query(collection(db, "usuarios"), where("roles", "array-contains", "tecnico"));
            const unsubTechs = onSnapshot(qTechsNew, (snapshotNew) => {
                const techMap = {};
                snapshotNew.forEach(doc => { techMap[doc.id] = doc.data().nombreCompleto; });
                getDocs(qTechsOld).then(snapshotOld => {
                    snapshotOld.forEach(doc => {
                        if (!techMap[doc.id]) {
                            techMap[doc.id] = doc.data().nombreCompleto;
                        }
                    });
                });
            }, (error) => {
                if (error.code !== 'permission-denied') console.error(error);
            });
            const qInvoices = query(collection(db, "facturas"));
            const unsubInvoices = onSnapshot(qInvoices, (snapshot) => {
                const invMap = {};
                snapshot.forEach(doc => { invMap[doc.id] = doc.data().folio; });
                setInvoicesMap(invMap);
            }, (error) => {
                if (error.code !== 'permission-denied') console.error(error);
            });

            return () => {
                unsubTechs();
                unsubInvoices();
            };
        };
        const unsubscribe = fetchExtraData();
        return () => unsubscribe();
    }, []);

    const handleToggleRow = (projectId) => {
        setExpandedRowId(prevId => (prevId === projectId ? null : projectId));
    }; 
    
    const filteredProjects = userRole === 'administrador'
    ? projects.filter(p => (p.npu?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.clienteNombre?.toLowerCase().includes(searchTerm.toLowerCase())) || (p.servicioNombre?.toLowerCase().includes(searchTerm.toLowerCase())))
    : projects;

    const currentItems = filteredProjects.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    const handleActivateProject = async (projectId) => {
        await updateDoc(doc(db, PROYECTOS_COLLECTION, projectId), { estado: 'Activo', estadoCliente: 'Activo' });
    };

    const handleDeleteProject = async (projectId) => {
        await deleteDoc(doc(db, PROYECTOS_COLLECTION, projectId));
        setConfirmingAction(null);
    };

    const promptDeleteProject = (projectId, projectNpu) => {
        setConfirmingAction({
            title: "Confirmar Eliminación",
            message: `¿Estás seguro de que quieres borrar el proyecto ${projectNpu}? Esta acción no se puede deshacer.`,
            onConfirm: () => handleDeleteProject(projectId),
            confirmText: "Sí, Borrar",
            confirmColor: "bg-red-600"
        });
    };

    return (
        <>
            {userRole === 'administrador' && (
                <div className="mb-4 flex flex-col md:flex-row justify-between items-center">
                    <input
                        type="text"
                        placeholder="Buscar por NPU, cliente, servicio o dependencia..."
                        className="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md mb-2 md:mb-0"
                        onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                    <div className="flex items-center">
                        <span className="text-sm mr-2">Mostrar:</span>
                        <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>
                </div>
            )}
            
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        {userRole === 'supervisor' && supervisorView === 'new' && (
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Apertura</th>
                                {/*<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">NPU</th>*/}
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Servicio</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Detalles</th>
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                            </tr>   
                        )}

                        {userRole === 'supervisor' && supervisorView === 'techDetail' && (
                            <tr>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase">Estado</th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase">Prioridad</th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase">Horas (Reg/Est)</th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase">Servicio</th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase">Ver Más</th>
                            </tr>
                        )}

                        {userRole === 'administrador' && (
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Apertura</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">NPU</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Servicio</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Proveedor</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº Proy. Lab.</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Comentarios</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">PO Prov.</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Precio</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Costo</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ref. Cliente</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ref. Proveedor</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fact. Cliente</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fact. Proveedor</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                                </tr>
                            )}
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200">
                        {currentItems.map(project => {
                            const isExpanded = expandedRowId === project.id;
                            let deliveryStatus = 'A Tiempo';
                            if (userRole === 'supervisor') {
                                const today = new Date(); today.setHours(0,0,0,0);
                                const dueDate = project.fechaEntregaInterna?.toDate();
                                if (!dueDate) {
                                    deliveryStatus = 'Sin Fecha';
                                } else {
                                    dueDate.setHours(0,0,0,0);
                                    if (dueDate < today) deliveryStatus = 'Atrasado';
                                    else if ((dueDate - today) / (1000 * 60 * 60 * 24) <= 3) deliveryStatus = 'Por Vencer';
                                }
                            }
                            const isEcotech = project.proveedorNombre?.toLowerCase().includes('ecotech');
                            return (
                                    <React.Fragment key={project.id}>
                                        <tr className={isExpanded ? 'bg-blue-50' : ''}>
                                            {userRole === 'administrador' && (
                                                <>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm">{formatDate(project.fechaApertura)}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm font-medium">{project.npu}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.clienteNombre}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.servicioNombre}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.proveedorNombre}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm">{project.datosEcotech?.numeroProyecto || '---'}</td>
                                                    <td className="px-6 py-4 text-sm text-gray-500" title={project.comentariosApertura}>
                                                        <p className="w-32 truncate">{project.comentariosApertura || '---'}</p>
                                                    </td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.poProveedor}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm text-green-600">${(project.precioCotizacionCliente || 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm text-red-600">${(project.costoProveedor || 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 text-xs">
                                                        <p><strong>Cot:</strong> {project.cotizacionClienteRef || 'N/A'}</p>
                                                        <p><strong>PO:</strong> {project.poClienteRef || 'N/A'}</p>
                                                    </td>
                                                    <td className="px-4 py-2 text-xs">
                                                        <p><strong>Cot:</strong> {project.cotizacionProveedorRef || 'N/A'}</p>
                                                    </td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{invoicesMap[project.facturaClienteId] || '---'}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{invoicesMap[project.facturaProveedorId] || (project.proveedorNombre?.toLowerCase().trim() === "ecologia y asesoria ambiental" ? 'N/A' : '---')}</td>
                                                    <td className="px-4 py-2"><span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${project.estado === 'Activo' ? 'bg-orange-100 text-orange-800' : 'bg-gray-100 text-gray-800'}`}>{project.estado}</span></td>
                                                    <td className="px-4 py-2">
                                                        <div className="flex items-center space-x-4">
                                                            {project.estado === 'Cotización' && <button onClick={() => handleActivateProject(project.id)} className="text-green-600">Activar</button>}
                                                            <button onClick={() => onManageClick(project)} className="text-indigo-600">Gestionar</button>
                                                            {project.estado !== 'Terminado' && project.estado !== 'Archivado' && <button onClick={() => promptDeleteProject(project.id, project.npu)} className="text-red-600">Borrar</button>}
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                            {userRole === 'supervisor' && supervisorView === 'new' && (
                                                <>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm">{formatDate(project.fechaApertura)}</td>
                                                    {/*<td className="px-4 py-2 whitespace-nowrap text-sm font-medium">{project.npu}</td>*/}
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.clienteNombre}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.servicioNombre}</td>
                                                    <td className="px-4 py-2 whitespace-nowrap text-sm">{project.comentariosApertura || 'N/A'}</td>
                                                    <td className="px-4 py-2">
                                                        <button onClick={() => onAssignClick(project)} className="text-indigo-600 font-medium">Asignar</button>
                                                    </td>
                                                </>    
                                            )}
                                            {userRole === 'supervisor' && supervisorView === 'techDetail' && (
                                                <>
                                                    <td className="px-4 py-3"><StatusBadge status={deliveryStatus} /></td>
                                                    <td className="px-4 py-3 text-sm">{project.prioridad || '1 - Normal'}</td>
                                                    <td className="px-4 py-3 text-sm">
                                                        <span className="font-semibold">{(project.horasRegistradas || 0).toFixed(1)}h</span> / 
                                                        <span className="text-gray-600">{(project.horasEstimadas || 0).toFixed(1)}h</span>
                                                    </td>
                                                    <td className="px-4 py-3 text-sm">{project.servicioNombre}</td>
                                                    <td className="px-4 py-3">
                                                        <button onClick={() => handleToggleRow(project.id)} className="text-indigo-600 font-medium">
                                                            {expandedRowId === project.id ? 'Ocultar' : 'Detalles...'}
                                                        </button>
                                                    </td>
                                                </>
                                            )}
                                        </tr> 
                                        {isExpanded && (
                                            <tr className="bg-gray-50 border-b-2 border-blue-200">
                                                <td colSpan={userRole === 'administrador' ? 16 : 5} className="p-4">
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                                                        <div><p className="font-semibold">Cliente:</p><p>{project.clienteNombre}</p></div>
                                                        <div><p className="font-semibold">Fecha Límite (Supervisor):</p><p>{formatDate(project.fechaEntregaInterna)}</p></div>
                                                        <div>
                                                            <p className="font-semibold">Estado Detallado:</p>
                                                            {project.fechaFinTecnicoReal ? (
                                                                <p className="text-purple-800">EL técnico finalizó el dia {formatDate(project.fechaFinTecnicoReal)}, en espera de proveedor o resolutivo.</p>
                                                            ) : (
                                                                <p className="text-gray-600">El técnico está trabajando en el proyecto.</p>
                                                            )}
                                                        </div>
                                                        <div className="col-span-3 bg-yellow-50 p-3 rounded-md border border-yellow-200">
                                                            <p className="font-semibold text-yellow-800">Comentarios</p>
                                                            <p className="text-gray-700 whitespace-pre-wrap mt-1">{project.comentariosApertura || 'Sin instrucciones específicas.'}</p>
                                                        </div>
                                                        <div className="col-span-full"><p className="font-semibold">Notas del Supervisor:</p><p className="text-gray-600 whitespace-pre-wrap">{project.notasSupervisor || 'No hay notas.'}</p></div>
                                                        {isEcotech && (
                                                            <div className="col-span-3 border-t pt-2 mt-2">
                                                                <p className="font-semibold text-gray-800">Info Ecotech:</p>
                                                                <p><strong>Nº Proy:</strong> {project.datosEcotech?.numeroProyecto || 'N/A'}, <strong>Puntos:</strong> {project.datosEcotech?.puntosDeTrabajo || 'N/A'}, <strong>Estatus:</strong> {project.datosEcotech?.estatus || 'N/A'}</p>
                                                            </div>
                                                        )}
                                                        <div className="col-span-full flex justify-end items-center space-x-4 border-t pt-3 mt-2">
                                                            <button onClick={() => onAssignClick(project)} className="bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-yellow-600">
                                                                Reasignar Técnico
                                                            </button>
                                                            <button onClick={() => onManageClick(project)} className="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700">
                                                                Gestionar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="mt-4 flex justify-between items-center">
                    <span className="text-sm text-gray-700">Página {currentPage} de {totalPages}</span>
                    <div>
                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                    </div>
                </div>
                
                {confirmingAction && <ConfirmationModal {...confirmingAction} onCancel={() => setConfirmingAction(null)} />}
        </>
    );
};